import { render, staticRenderFns } from "./subordersAssignedInfo.vue?vue&type=template&id=cfb72e66&"
import script from "./subordersAssignedInfo.vue?vue&type=script&lang=js&"
export * from "./subordersAssignedInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports